import RegisterNewUser from './RegisterNewUser';

export default RegisterNewUser;
